/**
 * Снятие заставки.
 *
 * Сама заставка живёт в index.html и показывается раньше сборки —
 * в этом весь её смысл. Отсюда ею только управляют: приложение знает,
 * когда оно действительно готово, а страница — нет.
 */

/**
 * Сколько заставка держится как минимум.
 *
 * На быстром соединении сборка приезжает за долю секунды, и заставка
 * мелькала бы вспышкой — это читается как сбой, а не как заставка.
 * Полторы доли секунды — ровно один проход анимации знака.
 */
const MIN_SHOW_MS = 900;

/** Сколько длится растворение. Совпадает с переходом в index.html. */
const FADE_MS = 420;

const started = Date.now();

export function hideSplash(): void {
  const splash = document.getElementById('ls-splash');
  if (!splash) return;

  const wait = Math.max(0, MIN_SHOW_MS - (Date.now() - started));

  window.setTimeout(() => {
    splash.classList.add('is-done');

    // Элемент убирается из потока, а не только гасится: прозрачная
    // плашка поверх всего экрана продолжала бы ловить нажатия.
    window.setTimeout(() => splash.setAttribute('hidden', ''), FADE_MS);
  }, wait);
}
